import { render, staticRenderFns } from "./SkuComponent.vue?vue&type=template&id=5dc7a9f0&"
import script from "./SkuComponent.vue?vue&type=script&lang=js&"
export * from "./SkuComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkuComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports